import axios from './config/axios'

const submitFinalized = (data) => {
  return axios
    .post('/api/forms/finalize', data)
    .then(r => r.data)
}
export default submitFinalized